import { useState } from 'react'
import { AppBar, IconButton, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import { ClearIcon, WSearchIcon } from '@weblite/icons'
import { BackButton } from '$common/buttons'
import { t } from '$setup/internationalization'
import { PageToolbar } from '$common/app-bar/common/page-toolbar'
import { AppBarSearchInput } from '$common/input/app-bar-search-input'

const TitleTypography = styled(Typography)`
  margin-right: 7px;
  flex-grow: 1;
`

interface Prop {
  title: string
  onBack: () => any
  setQuery: (query: string) => void
}

export function AppBarBackTitleSearch({ title, onBack, setQuery }: Prop) {
  const [inSearchMode, setInSearchMode] = useState<boolean>(false)

  return (
    <AppBar position="static">
      <PageToolbar>
        <BackButton onClick={onBack} />

        {inSearchMode ? (
          <AppBarSearchInput
            autoFocus
            fullWidth
            placeholder={t('common.search')}
            onChange={e => setQuery(e.target.value)}
          />
        ) : (
          <TitleTypography
            textAlign="right"
            color="neutral900"
            variant="subtitle1"
          >
            {title}
          </TitleTypography>
        )}

        <IconButton
          onClick={() => {
            setInSearchMode(!inSearchMode)
            if (inSearchMode) setQuery('')
          }}
        >
          {inSearchMode ? (
            <ClearIcon sx={{ color: 'neutral900' }} />
          ) : (
            <WSearchIcon sx={{ color: 'neutral900' }} />
          )}
        </IconButton>
      </PageToolbar>
    </AppBar>
  )
}
